import { Box, IconButton, Tooltip } from '@chakra-ui/react';
import { ReactComponent as PreviewIcon } from 'assets/icons/preview.svg';
import { DESIGN_PREVIEW } from 'constants/mixpanel';
import { useVenngageE1Gate } from 'hooks/useVenngageE1Gate';
import { Mixpanel } from 'libs/third-party/Mixpanel/mixpanel';
import { ReactElement, memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { isStandalone } from 'utils/environment';

const testId = 'preview-infograph-button';

export const PreviewMenu = memo((): ReactElement => {
  const { t } = useTranslation('common_navbar');
  const { id } = useParams();
  const { venngageE2 } = useVenngageE1Gate();

  const templateCategory = venngageE2?.templateCategory?.category;
  const isPresentation = templateCategory === 'presentations';
  const tooltipLabel = isPresentation ? t('navbar.present-button') : t('navbar.preview-button');
  const label = t('navbar.preview-menu-label');

  const handleOpenModal = () => {
    Mixpanel.track(DESIGN_PREVIEW.eventName, {
      from: DESIGN_PREVIEW.from[isPresentation ? 'presentButton' : 'previewButton'],
    });
  };

  const privateLinkURL = useMemo(() => {
    const shareLinkId = isStandalone ? id : venngageE2?.privateLinkId;
    return new URL(`${window.location.origin}/pl/${shareLinkId}`).toString();
  }, [id, venngageE2]);

  return (
    <Box ml='auto'>
      <Tooltip label={tooltipLabel} placement='bottom' bg='black' hasArrow>
        <IconButton
          variant='ghost'
          size='sm'
          href={privateLinkURL}
          target='_BLANK'
          data-testid={testId}
          aria-label={label}
          icon={<PreviewIcon color='var(--vg-colors-font-500)' width={20} height={20} />}
          onClick={handleOpenModal}
          as={'a'}
        />
      </Tooltip>
    </Box>
  );
});
PreviewMenu.displayName = 'PreviewMenu';
